module.exports = __webpack_public_path__ + "static/img/welcome-image.b2feb12.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/welcome-image.svg
// module id = Cxwr
// module chunks = 1